import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const trtFollowupQuestions = [
  {
    field: 'trtFollowup_sex',
    label: 'What was your sex assigned at birth?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Male', key: 'male' },
        { value: 'Female', key: 'female' }
      ]
    },
    extras: { sendToBeluga: false }
  },
  {
    field: 'trtFollowup_height',
    label: 'What is your height in feet and inches?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'trtFollowup_height'
    }
  },
  {
    field: 'trtFollowup_weight',
    label: 'What is your weight in pounds?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'trtFollowup_weight'
    }
  },
  {
    field: 'trtFollowup_healthChanges',
    label:
      'Have there been any health changes, medication changes, ED visits or hospitalizations since your last check-in?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'No', key: 'no' },
        { value: 'Yes', key: 'yes' }
      ]
    }
  },
  {
    field: 'trtFollowup_healthChangesDetails',
    label: 'Please tell us more about the changes in your health',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'trtFollowup_healthChangesDetails'
    }
  },
  {
    field: 'trtFollowup_urgentSymptoms',
    label: 'In the past 72 hours, have you experienced any of the following:',
    educationalSlide: `- Chest pain or shortness of breath
- Severe dizziness or fainting
- Facial swelling, rash, or hives
- Thoughts of self-harm or feeling unsafe
`,
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes',
          key: 'yes'
        },
        {
          value: 'No',
          key: 'no'
        }
      ]
    }
  },
  {
    field: 'trtFollowup_medicationDoing',
    label: 'How are you doing on the current medication?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Well', key: 'well' },
        { value: 'Not well', key: 'not_well' }
      ]
    }
  },
  {
    field: 'trtFollowup_medicationExperience',
    label: 'Please tell us more about what you are experiencing',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'trtFollowup_medicationExperience'
    }
  },
  {
    field: 'trtFollowup_sideEffects',
    label: 'Have you experienced any side effects from the current medication?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'No', key: 'no' },
        { value: 'Yes', key: 'yes' }
      ]
    }
  },
  {
    field: 'trtFollowup_sideEffectsDetails',
    label: 'Please tell us more about the side effects you are experiencing',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'trtFollowup_sideEffectsDetails'
    }
  },
  {
    field: 'trtFollowup_testicularSizeDecrease',
    label: 'Are you noticing a decrease in testicular size or fullness?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'trtFollowup_lastDoseDate',
    label:
      'Please enter the exact date you last administered your testosterone dose. Accurate timing helps us safely determine your next scheduled dose.',
    type: 'info',
    answer: {
      type: 'text',
      name: 'trtFollowup_lastDoseDate'
    }
  },
  {
    field: 'trtFollowup_doseAdjusted',
    label:
      'Has your dose been adjusted by another provider or have you self adjusted your dose since your last visit?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes, this has been adjusted', key: 'yes_adjusted' },
        {
          value:
            "No, I'm taking the same dose that was prescribed during my last appointment",
          key: 'no_same_dose'
        }
      ]
    }
  },
  {
    field: 'trtFollowup_doseAdjustedDetails',
    label:
      'Please provide more information about who adjusted your dose, why this was adjusted, and what is your current dose?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'trtFollowup_doseAdjustedDetails'
    }
  },
  {
    field: 'trtFollowup_treatmentPreference',
    label:
      'Would you like to continue your current treatment, change the dose, or change the medication?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            "I'm doing well and I would like to continue what I'm on",
          key: 'continue_current'
        },
        {
          value:
            "I like the medication but I would like to increase the dose if I'm not on the max dose already",
          key: 'increase_dose'
        },
        {
          value:
            'I like the medication but I would like to decrease the dose',
          key: 'decrease_dose'
        },
        {
          value: 'I would like to change the medication',
          key: 'change_medication'
        },
        {
          value:
            "I'm not sure, have the provider reach out to discuss further",
          key: 'provider_reach_out'
        }
      ]
    }
  },
  {
    field: 'trtFollowup_symptomImprovement',
    label:
      'Since starting your treatment, how would you describe your overall symptom improvement?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Much improved', key: 'much_improved' },
        { value: 'Slightly improved', key: 'slightly_improved' },
        { value: 'No change', key: 'no_change' },
        { value: 'Slightly worse', key: 'slightly_worse' },
        { value: 'Much worse', key: 'much_worse' }
      ]
    }
  },
  {
    field: 'trtFollowup_energyChange',
    label:
      'Have you noticed changes in your energy, motivation, or ability to carry out daily activities?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'A lot better', key: 'a_lot_better' },
        { value: 'A little better', key: 'a_little_better' },
        { value: 'No change', key: 'no_change' },
        { value: 'A little worse', key: 'a_little_worse' },
        { value: 'A lot worse', key: 'a_lot_worse' }
      ]
    }
  },
  {
    field: 'trtFollowup_moodChange',
    label: 'How has your overall mood or emotional well-being changed?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Much improved', key: 'much_improved' },
        { value: 'Slightly improved', key: 'slightly_improved' },
        { value: 'No change', key: 'no_change' },
        { value: 'Slightly worse', key: 'slightly_worse' },
        { value: 'Much worse', key: 'much_worse' }
      ]
    }
  },
  {
    field: 'trtFollowup_physicalPerformanceChange',
    label:
      'Have you experienced any changes in your physical strength, stamina, or exercise tolerance?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Improved significantly', key: 'improved_significantly' },
        { value: 'Improved somewhat', key: 'improved_somewhat' },
        { value: 'No noticeable change', key: 'no_noticeable_change' },
        { value: 'Worsened somewhat', key: 'worsened_somewhat' },
        { value: 'Worsened significantly', key: 'worsened_significantly' }
      ]
    }
  },
  {
    field: 'trtFollowup_workConcentrationChange',
    label:
      'Has your ability to work, concentrate, or complete daily tasks changed?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Much easier', key: 'much_easier' },
        { value: 'Somewhat easier', key: 'somewhat_easier' },
        { value: 'No change', key: 'no_change' },
        { value: 'Somewhat harder', key: 'somewhat_harder' },
        { value: 'Much harder', key: 'much_harder' }
      ]
    }
  },
  {
    field: 'trtFollowup_sexualFunctionChange',
    label:
      'Have you noticed any changes in your sexual desire, performance, or satisfaction?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Much improved', key: 'much_improved' },
        { value: 'Slightly improved', key: 'slightly_improved' },
        { value: 'No change', key: 'no_change' },
        { value: 'Slightly worse', key: 'slightly_worse' },
        { value: 'Much worse', key: 'much_worse' }
      ]
    }
  },
  {
    field: 'trtFollowup_additionalQuestions',
    label: 'What other information or questions do you have for the doctor?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'trtFollowup_additionalQuestions'
    }
  },
  {
    field: 'trtFollowup_consent',
    label: 'TRT, HCG, and SERM-Based Therapy Informed Consent',
    type: 'select',
    educationalSlide: `You are requesting evaluation and possible treatment for symptoms related to low testosterone. Treatment options may include:
- Testosterone Replacement Therapy (TRT)
- Human Chorionic Gonadotropin (HCG)
- Selective Estrogen Receptor Modulators (SERMs) such as clomiphene or enclomiphene
- Aromatase inhibitors (AIs) when clinically appropriate

These therapies may be used alone or in combination depending on your symptoms, laboratory results, and treatment goals (including fertility preservation).

TRT may be administered as an injection, gel, oral regimen, cream, or nasal formulation. HCG, SERMs, and AIs are oral or injectable therapies used to stimulate or regulate endogenous hormone production. All treatment is prescribed and monitored by a licensed healthcare provider.

Potential Benefits
Treatment may improve:
- Energy, libido, and sexual function
- Muscle mass, strength, and exercise tolerance
- Mood and overall well-being
HCG and SERMs may help stimulate natural testosterone production and support fertility in some patients.

Risks and Side Effects
TRT:
- Acne, oily skin
- Fluid retention
- Mood changes
- Testicular shrinkage and reduced sperm production
- Elevated red blood cell count

HCG:
- Injection site irritation
- Headache or mood changes
- Gynecomastia
- Increased estrogen levels

Clomiphene / Enclomiphene (SERMs):
- Headache
- Mood changes
- Visual disturbances (rare but important)
- Possible liver or lipid changes

Aromatase Inhibitors (AIs):
- Joint pain
- Fatigue
- Low estrogen symptoms (e.g., mood or libido changes)
- Decreased bone density with long-term use

Serious (rare) risks:
- Elevated hematocrit
- Cardiovascular events (clot, stroke, heart attack)
- Worsening sleep apnea
- Liver abnormalities
- Allergic reactions

Seek emergency care for chest pain, shortness of breath, severe headache, or leg swelling.

Fertility Considerations
- TRT may suppress sperm production and lead to infertility
- HCG and SERMs may help preserve or stimulate fertility, but this is not guaranteed

Compounded Medications
Some therapies may be compounded and not FDA-approved. These may be used when clinically appropriate; however, comparative safety and efficacy data may be limited.

Contraindications
You must disclose any history of:
- Prostate or breast cancer
- Polycythemia
- Severe heart disease or recent stroke
- Untreated sleep apnea
- Allergy to any prescribed therapy

Monitoring Requirements
Ongoing treatment requires periodic labs (typically every 3–6 months), which may include:
- CBC (hematocrit)
- Testosterone levels
- PSA (when appropriate)
- Liver function and lipids
- Estradiol (when indicated)

Failure to complete required monitoring may result in dose adjustment or discontinuation.

Alternatives
- No treatment
- Lifestyle optimization (sleep, exercise, weight loss)
- Non-hormonal therapies
- HCG or SERMs alone (fertility-focused approaches)

Truthfulness and Accuracy of Information
I acknowledge that the safety and appropriateness of my treatment depend on the accuracy and completeness of the information I provide. I confirm that:
- All medical history, medications, allergies, and symptoms I have provided are true, accurate, and complete to the best of my knowledge
- I will update my provider if there are any changes to my health, medications, or symptoms
- I understand that failure to provide accurate or complete information may increase my risk of adverse outcomes and may result in discontinuation of care

Acknowledgment and Consent
I understand:
- The risks, benefits, and alternatives of TRT, HCG, SERMs, and AIs
- No outcomes are guaranteed
- Ongoing monitoring is required
- My treatment may be modified or discontinued for safety

I consent to evaluation and treatment under medical supervision.`,
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read the above information and I do NOT wish to continue',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value:
            'I have read the above information and I do consent and wish to move forward',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    field: 'trtFollowup_complete',
    isLast: true,
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'trtFollowup_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    extras: { sendToBeluga: false },
    answer: {},
    reject: true,
    type: 'info',
    isLast: true
  },
  {
    class: 'ineligible',
    field: 'trtFollowup_didNotConsent',
    label: 'We need your consent to continue',
    subLabel:
      'You did not agree to the terms shown on the previous step. Without that consent, we cannot move forward with your visit or prescribe treatment.',
    extras: { sendToBeluga: false },
    reject: true,
    answer: {},
    type: 'info',
    isLast: true
  }
] as const;

export type TrtFollowupFieldAnswers = Partial<
  QuestionAnswerMap<typeof trtFollowupQuestions>
>;
export default trtFollowupQuestions;

